import Navbar from '../components/Navbar';
import BackgroundPattern from '../components/BackgroundPattern';
import AdminSection from '../components/AdminSection';
import Footer from '../components/Footer';

const AdminPage = () => {
  return (
    <div className="min-h-screen text-white overflow-hidden relative" style={{ backgroundColor: '#0a0a1a' }}>
      <BackgroundPattern />
      <Navbar />
      <AdminSection forceOpen />
      <Footer />
    </div>
  );
};

export default AdminPage;
